/**
 * Malaysia Annual Return Feature Routes
 * 일반 Entity 진입은 Entity_my 의 Detail 페이지에서 연결 예정이지만,
 * 현재는 standalone 경로로 진입 (entityCd + arDate picker).
 */

import type { RouteRecordRaw } from 'vue-router';
import { useSessionStore } from '@/shared/stores/sessionStore';

// jurisdiction == MY 가드
const checkJurisdictionMY = (to: any, _from: any, next: any) => {
  const sessionStore = useSessionStore();
  const customerInfo = sessionStore.getCustomerInfo();
  if (customerInfo?.jurisdiction === 'MY') {
    next();
  } else {
    next({ path: '/Entity', replace: true });
  }
};

export const annualReturnMyRoutes: RouteRecordRaw[] = [
  {
    path: '/annual-return_my/:entityCd',
    name: 'AnnualReturnMyPreview',
    component: () => import('./views/ARPreviewPage.vue'),
    beforeEnter: checkJurisdictionMY,
    meta: {
      title: 'Annual Return Preview',
      titleKey: 'annualReturn.Annual Return Preview',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/Annual-return_my/:entityCd',
    name: 'AnnualReturnMyPreviewUpper',
    component: () => import('./views/ARPreviewPage.vue'),
    beforeEnter: checkJurisdictionMY,
    meta: {
      title: 'Annual Return Preview',
      titleKey: 'annualReturn.Annual Return Preview',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/annual-return_my/:entityCd/:arIdx',
    name: 'AnnualReturnMyEditor',
    component: () => import('./views/ARPreviewPage.vue'),
    beforeEnter: checkJurisdictionMY,
    meta: {
      title: 'Annual Return Editor',
      titleKey: 'annualReturn.Annual Return Editor',
      requiresAuth: true,
      layout: 'default',
    },
  },
];

export default annualReturnMyRoutes;
